"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const chatMessage_1 = __importDefault(require("./chatMessage"));
const chatEvents_1 = __importDefault(require("../../lib/chatEvents"));
const configureStore_1 = require("../../store/configureStore");
const ChatRoom = (props) => {
    const { socket } = props;
    const [userId, setUserId] = (0, react_1.useState)('');
    const [chatLog, setChatLog] = (0, react_1.useState)([]);
    const { secretKey } = (0, react_1.useContext)(configureStore_1.StoreContext);
    (0, react_1.useEffect)(() => {
        const Events = new chatEvents_1.default(socket, secretKey);
        Events.receiveMessages((msg) => {
            setChatLog((arr) => [
                ...arr,
                Object.assign(Object.assign({}, msg), { time: `${new Date().toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' })}` })
            ]);
        });
        setUserId(socket.id);
        return () => {
            setChatLog([]);
            setUserId('');
        };
    }, []);
    const Room = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (chatLog.length > 0) {
            if (Room.current.scroll) {
                Room.current.scroll(0, Room.current.scrollHeight);
            }
        }
    }, [chatLog]);
    return (react_1.default.createElement("div", { "data-testid": "chat-room", style: {
            display: "flex",
            flexFlow: "column nowrap",
            flex: "1 0px",
            background: "#E6DDC4",
            overflow: "auto",
        }, ref: Room },
        react_1.default.createElement(chatMessage_1.default, { messages: chatLog, userId: userId })));
};
exports.default = ChatRoom;
